import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9362d82a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-loading" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "circular",
    viewBox: "-10, -10, 50, 50"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "path",
      d: "\r\n\t\t\t\t\t\tM 30 15\r\n\t\t\t\t\t\tL 28 17\r\n\t\t\t\t\t\tM 25.61 25.61\r\n\t\t\t\t\t\tA 15 15, 0, 0, 1, 15 30\r\n\t\t\t\t\t\tA 15 15, 0, 1, 1, 27.99 7.5\r\n\t\t\t\t\t\tL 15 15",
      style: {"stroke-width":"4px","fill":"rgba(0, 0, 0, 0)"}
    })
  ])
], -1))
const _hoisted_2 = {
  key: 0,
  class: "custom-loading",
  style: {"width":"24px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    type: "primary",
    class: "button-loading",
    onClick: _ctx.onClick,
    disabled: _ctx.disabled,
    loading: _ctx.loading
  }, {
    loading: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "   "))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.label ?? 'Button1'), 1)
    ]),
    _: 1
  }, 8, ["onClick", "disabled", "loading"]))
}